var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// (webpack)/~/isarray/index.js
// module id = 440
// module chunks = 1 4 5 6 8 9 10 12 14 15 21 22 24 27 28 58